import React from "react";
import { FormGroup, Label, Input, InputProps } from "reactstrap";

import "./Input.scss";
interface FormInputProps extends InputProps {
  name: string;
  label?: string;
  error?: any;
  touched?: any;
}

const FormInput: React.FC<FormInputProps> = ({ name, label, error, touched, ...inputProps }) => {
  return (
    <FormGroup>
      {label && <Label htmlFor={name}>{label}</Label>}

      <Input invalid={touched && error} id={name} name={name} {...inputProps} />
      {touched && error && <small className='text-danger fw-medium'>{error}</small>}
    </FormGroup>
  );
};

export default FormInput;
